import { jsx as _jsx } from "react/jsx-runtime";
import { WalletAPIClient } from "@ledgerhq/wallet-api-client";
import { useEffect, useMemo, useState } from "react";
import { WalletAPIProviderContext, initialContextValue } from "./context";
export function WalletAPIProvider({ children, transport, logger, getCustomModule, }) {
    const [client, setClient] = useState();
    const [state, setState] = useState(initialContextValue.state);
    useEffect(() => {
        const walletApiClient = new WalletAPIClient(transport, logger, getCustomModule);
        setClient(walletApiClient);
    }, [getCustomModule, logger, transport]);
    const value = useMemo(() => ({
        client,
        state,
        setState,
    }), [client, state, setState]);
    return (_jsx(WalletAPIProviderContext.Provider, { value: value, children: children }));
}
//# sourceMappingURL=index.js.map